<template>
  <PageLayout class="accident-lawyer-page">
    <AccidentLawyer />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import AccidentLawyer from '../../views/accidentLawyer/index.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';

export default {
  created() {
    this.changeActivePage(pages.HOME);
  },
  components: { PageLayout, AccidentLawyer },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
</style>
